import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Layout } from "../components";
import { GalleryMenu } from "../components";
import GalleryComponent from "../components/GalleryComponent/GalleryComponent.jsx";

const Gallery = (props) => {
  const { stage } = useParams();
  const [photos, setPhotos] = useState([]);
  const DbParams = {
    registros: "caribe-2023-summary",
    prologo: "caribe-2023-prologue",
    "etapa-1": "caribe-2023-stage1",
    "etapa-2": "caribe-2023-stage2",
    "etapa-3": "caribe-2023-stage3",
    "etapa-4": "caribe-2023-stage4",
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/gallery-caribe/${DbParams[stage]}`)
      .then((res) => res.json())
      .then((res) => {
        setPhotos(res.photos);
      });
  }, [stage]);

  return (
    <div className="Gallery">
      <Layout showInternalMenu={false}>
        <GalleryMenu />
        <div className="container">
          {photos.length > 0 ? (
            <GalleryComponent city="punta-cana" images={photos} />
          ) : (
            <p style={{ marginTop: "20px", marginBottom: "20px" }}>
              Próximamente
            </p>
          )}
        </div>
      </Layout>
    </div>
  );
};

export default Gallery;
